package com.essntl.features.paymentparameter.data.supabase

import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun PaymentParameterModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    if (!name.isNullOrEmpty()) {
        requestMap["name"] = JsonPrimitive(name)
    }

    if (amount != null) {
        requestMap["amount"] = JsonPrimitive(amount)
    }

    if (isInvoice != null) {
        requestMap["is_invoice"] = JsonPrimitive(isInvoice)
    }

    if (applyToAmount != null) {
        requestMap["apply_to_amount"] = JsonPrimitive(applyToAmount)
    }

    if (method != null) {
        requestMap["method"] = JsonPrimitive(method!!.toDto())
    }

    if (type != null) {
        requestMap["type"] = JsonPrimitive(type!!.toDto())
    }

    if (!qbItemId.isNullOrEmpty()) {
        requestMap["qb_item_id"] = JsonPrimitive(qbItemId)
    }

    return requestMap
}
